import { useTranslation } from "react-i18next";
import Helpers from "../../utils/helpers";
 
const OrderReviewDeliveryAddress = (props: any) => {
  const { t } = useTranslation();
 
  const formatAddressLine = (parts: (string | undefined)[], separator = ', ') => {
    const validParts = parts.filter(part => part && part.trim() !== '');
    return validParts.join(separator);
  };
 
  const renderAddress = () => {
    if (!props.addressDetails ||
        !props.addressDetails.props ||
        !props.addressDetails.props.orderinfo ) {
      return null;
    }
 
    const addressDetails1 = props.addressDetails?.props?.orderinfo;
 
    const addressLines = [
      addressDetails1?.address1,
      addressDetails1?.address2,
      addressDetails1?.landmark,
      formatAddressLine([
        addressDetails1?.areaName,
        addressDetails1?.subDistrictName,
      ]),
      formatAddressLine([
        addressDetails1?.cityName,
        addressDetails1?.stateName,
        addressDetails1?.countryName,
        addressDetails1?.zipcode ? `-${addressDetails1.zipcode}` : ''
      ], ' ')
    ].filter(line => line && line.trim() !== '');
 
    return (
      <>
        {addressLines.map((line, index) => (
          <p key={`address-line-${index}`} className="mb-0">
            {line}
            {index !== addressLines.length - 1 ? ',' : '.'}
          </p>
        ))}
      </>
    );
  };
 
  const paymentMode = props.addressDetails?.props?.orderinfo?.paymentMode || '';
 
  return (
    <>
      <div className="text-900small">
        <p className="font-bold">{t("ordersummary_delivery_address")}</p>
        {renderAddress()}
        <br />
        <p className="font-bold">
          {t("ordersummary_payment_mode")} : {Helpers.formatPaymentMode(paymentMode)}
        </p>
      </div>
    </>
  );
};
 
export default OrderReviewDeliveryAddress;
 